
// 期間の正規表現フォーマット
const REGEX = /(20\d\d)\/([0-1]\d)\/([0-3]\d) ([0-2]\d):([0-5]\d)/;
// 日付フォーマット
const DATETIME_FORMAT = 'YYYY/MM/DD HH:mm';

/**
 * 反映予約用日時設定セレクトボックスコンポーネント
 */
export default {
    template: '#datetime_selectbox_editor_template',
    data() {
        return {
            selected: {}
        };
    },
    props: {
        // YYYY/MM/DD HH:mm
        modelValue: {
            type: String,
            required: false,
            default: 'datetime',
        },
    },
    watch: {
        // 親コンポーネントの変更時、セレクトボックスに適用
        modelValue: {
            immediate: true,
            handler(value) {
                this.selected = this.convertObject(value);
            }
        },
        // セレクトボックスの変更時、親へ通知
        selected: {
            handler: function () {
                this.emitUpdateValue();
            },
            deep: true
        }
    },
    computed: {
        years: function () {
            if(!this.modelValue) {
                return null;
            }
            const m = moment(this.modelValue, DATETIME_FORMAT);
            const nowMoment = m.clone();
            const advancedMoment = m.add(7, 'days');

            let years = [nowMoment.format('YYYY')];
            // 年をまたぐ場合翌年を追加
            if (advancedMoment.format('YYYY') !== years[0]) {
                years.push(advancedMoment.format('YYYY'));
            }
            return years;
        },
        months: function () {
            const m = moment(this.modelValue, DATETIME_FORMAT);
            const nowMoment = m.clone();
            const advancedMoment = m.add(7, 'days');

            let months = [nowMoment.format('MM')];
            // 月をまたぐ場合翌月を追加
            if (advancedMoment.format('MM') !== months[0]) {
                months.push(advancedMoment.format('MM'));
            }
            return months;
        },
        days: function () {
            let days = [];
            const m = moment(this.modelValue, DATETIME_FORMAT);
            days.push(m.format('DD'));

            for (let i = 0; i < 7; i++) {
                days.push(m.add(1, 'days').format('DD'));
            }
            return days;
        },
    },
    emits: ['update:modelValue'],
    methods: {
        // 先頭に0を付けて桁をそろえる
        zeroPadding: function (num) {
            return ('00' + num).slice(-2);
        },
        // 日付文字列からobjectに変換
        convertObject: function (value) {
            if (value) {
                const matches = value.match(REGEX);
                if (matches) {
                    return {
                        year: matches[1],
                        month: matches[2],
                        day: matches[3],
                        hour: matches[4],
                        min: matches[5],
                    };
                }
            }
            return {
                year: null,
                month: null,
                day: null,
                hour: null,
                min: null
            };
        },
        // objectから日付文字列に変換
        convertText: function () {
            return this.selected.year + '/' + this.selected.month + '/' + this.selected.day + ' ' + this.selected.hour + ':' + this.selected.min;
        },
        // 変更を親へ通知
        emitUpdateValue: function () {
            // nullが1つでもあったらemitしない
            for (let i in this.selected) {
                if (this.selected[i] === null) {
                    return;
                }
            }
            this.$emit('update:modelValue', this.convertText());
        }
    }
};
